import { motion } from "framer-motion";
import { MessagesSquare, ClipboardList, PiggyBank, KeyRound } from "lucide-react";

const STEPS = [
  {
    icon: MessagesSquare,
    title: "Gente que escuta",
    text: "A gente entende seu objetivo e define juntos a carta de crédito e a parcela que caibam na sua vida.",
  },
  {
    icon: ClipboardList,
    title: "Plano sob medida",
    text: "Você entra em um grupo com valor, prazo e parcela planejados — sem análise de renda para começar.",
  },
  {
    icon: PiggyBank,
    title: "Contribuições em dia",
    text: "Você contribui mensalmente e, se quiser, usa o lance para aumentar as chances de antecipar a contemplação.",
  },
  {
    icon: KeyRound,
    title: "Carta de crédito",
    text: "Contemplado, você compra à vista e negocia melhor: a casa própria ou o carro da família.",
  },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="scroll-mt-24 bg-white py-24 md:py-32" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-600">Como funciona</p>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Simples assim: um plano, uma carta, sua conquista
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Consórcio é compra planejada em grupo: cada participante contribui mensalmente e o grupo
            contempla seus integrantes conforme as regras — por sorteio ou por lance.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 }}
              className="group relative rounded-3xl border border-slate-200/80 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-brand-900/5"
              data-testid={`how-it-works-step-${i + 1}`}
            >
              <span className="absolute right-6 top-6 font-display text-4xl font-extrabold text-slate-100 transition-colors group-hover:text-brand-100">
                0{i + 1}
              </span>
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-50 text-brand-600">
                <step.icon className="h-6 w-6" />
              </span>
              <h3 className="mt-5 font-display text-lg font-bold text-slate-900">{step.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-slate-600">{step.text}</p>
            </motion.div>
          ))}
        </div>

        <p className="mt-8 max-w-3xl text-xs leading-relaxed text-slate-400">
          Sem promessa de contemplação ou de prazo: a contemplação segue as regras do grupo vigente.
          O consórcio possui taxa de administração e fundo de reserva, informados na simulação oficial.
        </p>
      </div>
    </section>
  );
}
